import { domReady } from 'utilities/dom';
import { Reporter, visibilityObserver } from 'features/dataCapture';
import { setGenericEvent } from 'features/tealium/ga4/custom';
import { openMessenger } from 'features/genesysCloud';
import { trackDyRecommendedItemClickEvent } from 'features/tealium/dynamicYield/recommendedItemsTracking';

domReady(() => {

	initializeDataCapture();
	initDyEngagementTracking();

	const chatBtn = document.querySelector(
		'.contentWrap .chatButtonContainer button, .header .chatButtonContainer button'
	);

	if (chatBtn) {

		chatBtn.addEventListener('click', (e) => {

			openMessenger();
			setGenericEvent({
				event_name: 'chat_click',
				chat_button_type: 'static',
				chat_button_text: e.target.innerHTML
			});

		});

	}

});

const initializeDataCapture = () => {

	if (!window.lp.globals.enableDataCapture || !window.lp.globals.canShowCertona) {

		return;

	}

	const { reporter } = window.lp.dataCapture;

	const elementObserver = visibilityObserver((element) => {

		const data = Reporter.getSkuViewData(element);
		reporter.track(data);

	});
	document.addEventListener('recommendedItems:loaded', () => {

		const elements = document.querySelectorAll('#CertonaContainer img[data-sku]');
		elements.forEach((element) => elementObserver.observe(element));

	});

};

const initDyEngagementTracking = () => {

	document.addEventListener('recommendedItems:loaded', () => {

		const moreYouMayLikeWidget = document.querySelectorAll('[data-capture-section="MoreYouMayLikeWidget"] a');
		if (moreYouMayLikeWidget.length) {

			trackDyRecommendedItemClickEvent({ selector: moreYouMayLikeWidget });

		}

	});

};
